/** R2C2 arm control protocols (rosbridge or foxglove_bridge). No Spot legacy. */

export const ARM_CMD_VEL_MSG_TYPE = "geometry_msgs/msg/Twist";
export const ARM_TRIGGER_SERVICE_TYPE = "std_srvs/srv/Trigger";
export const ARM_STRING_MSG_TYPE = "std_msgs/msg/String";

/** Latched preset name for /arm/save_preset|/arm/goto_preset|/arm/delete_preset. */
export const ARM_PRESET_ARG_TOPIC = "/arm/preset_arg";

/**
 * Publish EE velocity in tool frame (m/s, rad/s).
 * @returns {[string, object, string]}
 */
export const setArmCmdVel = ({
    vx = 0,
    vy = 0,
    vz = 0,
    wx = 0,
    wy = 0,
    wz = 0,
} = {}) => [
    "/arm/cmd_vel",
    {
        linear: { x: vx, y: vy, z: vz },
        angular: { x: wx, y: wy, z: wz },
    },
    ARM_CMD_VEL_MSG_TYPE,
];

/** Zero twist — publish on stick release / blur. */
export const zeroArmCmdVel = () => setArmCmdVel({});

/** Publish the preset name used by the next named Trigger service call. */
export const setArmPresetArg = (name) => [
    ARM_PRESET_ARG_TOPIC,
    { data: String(name ?? "") },
    ARM_STRING_MSG_TYPE,
];

const trigger = (name) => [
    name,
    {},
    { serviceType: ARM_TRIGGER_SERVICE_TYPE },
];

export const armStop = () => trigger("/arm/stop");
export const armGoZero = () => trigger("/arm/go_zero");
export const armGripperOpen = () => trigger("/arm/gripper_open");
export const armGripperClose = () => trigger("/arm/gripper_close");
export const armPresetStow = () => trigger("/arm/preset_stow");
export const armPresetReady = () => trigger("/arm/preset_ready");
/** @deprecated Prefer armSavePreset(name); kept for backcompat. */
export const armSaveStow = () => trigger("/arm/save_stow");

export const armSavePresetTrigger = () => trigger("/arm/save_preset");
export const armGotoPresetTrigger = () => trigger("/arm/goto_preset");
export const armDeletePresetTrigger = () => trigger("/arm/delete_preset");
